var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.35547H13.3636C11.3142 1.35547 9.34877 1.91677 7.89963 2.91589C6.45048 3.915 5.63636 5.2701 5.63636 6.68306V9.87962H1V14.1417H5.63636V22.6658H11.8182V14.1417H16.4545L18 9.87962H11.8182V6.68306C11.8182 6.40047 11.981 6.12945 12.2708 5.92963C12.5607 5.7298 12.9538 5.61754 13.3636 5.61754H18V1.35547Z",
    stroke: "#D3D3D3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.b8da1df926e8ddbf208d995c47a04d38.svg";
export { ForwardRef as ReactComponent };